import { Building, Check } from "lucide-react";

const reasons = [
  "Education-first, non-promotional positioning",
  "Platform-agnostic structure",
  "Clear compliance boundaries",
  "Serious tone and disciplined standards",
  "Low reputational and regulatory risk"
];

const WhyOrganizations = () => {
  return (
    <section data-testid="why-organizations-section" className="section-dark">
      <div className="section-pattern"></div>
      <div className="section-glow bottom-right"></div>
      
      <div className="container narrow">
        <div className="section-header">
          <div className="section-icon">
            <Building />
          </div>
          <h2 className="section-title">Why Organizations Engage With FLEXX Academy</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="feature-list">
          {reasons.map((reason, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon" style={{ background: 'rgba(34, 197, 94, 0.1)' }}>
                <Check style={{ color: '#22c55e' }} />
              </div>
              <p className="feature-text">{reason}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyOrganizations;
